import { postApi } from "../../../shared/api/postApi"
import type { CompaniaArbol } from "../types/accesosOrganizacion.types"

// Árbol Compañía > Sucursal > Sede para el modal "Accesos por organización".
// Solo lo puede pedir quien administra usuarios (master); ante error devuelve [].
export const usuarioArbolOrganizacion = (dataPOST: { token?: string }) =>
    postApi<{ arbol: CompaniaArbol[] }, { arbol: CompaniaArbol[] }>(
        "api/sede/ArbolOrganizacion",
        dataPOST,
        (d) => ({ arbol: Array.isArray(d?.resultado) ? d.resultado : [] }),
        { arbol: [] },
    )
